<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryParams" :model="queryParams" :inline="true">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
          </el-form-item>
        </el-form>

        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import { exportPayStatData } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'IndexRegPay',
  data() {
    return {
      loading: false,
      reelection: false,
      reelectionName: '',
      reelectionClick: 0,
      chart: null,
      option: null,
      platForm: [{ label: '全部', value: '' }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }],
      country: [],
      queryParams: {
        startDate: '',
        endDate: '',
        lang: 'a'
      }
    }
  },
  created() {
    this.getUserVersionData()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      this.initChart()
    },
    getUserVersionData() {

    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.chart.showLoading()
      this.option = {
        title: {
          text: '注册付费统计'
        },
        legend: {
          data: ['首次付费人数', '注册付费人数', '首次付费金额', '注册付费金额', '注册付费率', '老付费率'],
          x: 'center',
          y: 'bottom'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0 // 设置为0，表示所有的标签都显示
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        }, {
          type: 'value',
          name: '百分比',
          axisLabel: {
            formatter: '{value} %'
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
      this.loading = true
      exportPayStatData(this.queryParams).then(res => {
        this.loading = false
        this.chart.hideLoading()
        if (res.code === 200) {
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          this.option.xAxis.data = []
          this.option.series = []
          const dateArr = []
          const regPay = res.data.regPay
          const firstPayCount = [] // 首次付费人数
          const regPayPrice = [] // 首次付费金额
          const firstPayPrice = [] // 首次付费金额
          const regPayUserCount = [] // 注册付费人数
          const payUserCount = [] // 老付费人数
          const regPayRate = [] // 注册付费率
          const payRate = [] // 老付费率
          for (const i in regPay) {
            const val = regPay[i]
            dateArr.push(dateStrTodate(val.date))
            firstPayCount.push(val.first_pay_count)
            firstPayPrice.push(val.first_pay_price)
            regPayPrice.push(val.reg_pay_price)
            regPayUserCount.push(val.reg_pay_user_count)
            payUserCount.push(val.pay_user_count)
            regPayRate.push(val.reg_pay_rate)
            payRate.push(val.pay_rate)
          }

          this.option.series.push({
            name: '首次付费人数',
            data: firstPayCount,
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          })

          this.option.series.push({
            name: '注册付费人数',
            data: regPayUserCount,
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          })

          this.option.series.push({
            name: '首次付费金额',
            data: firstPayPrice,
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          })

          this.option.series.push({
            name: '注册付费金额',
            data: regPayPrice,
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          })

          this.option.series.push({
            name: '注册付费率',
            data: regPayRate,
            yAxisIndex: 1,
            type: 'line',
            smooth: true
          })

          this.option.series.push({
            name: '活跃付费率',
            data: payRate,
            yAxisIndex: 1,
            type: 'line',
            smooth: true
          })

          this.option.xAxis.data = dateArr
          this.chart.setOption(this.option, true)
          // this.chart.on('legendselectchanged', this.handleClick)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClick(params) {
      const clickName = params.name
      const selected = params.selected
      if (this.reelectionName === '') {
        this.reelectionName = clickName
        this.reelectionClick++
      } else if (this.reelectionName !== clickName) {
        this.resetLegend(selected)
        return
      }

      if (this.reelectionClick > 2 && this.reelectionName === clickName) {
        this.resetLegend(selected)
        return
      }

      this.reelectionClick++
      const reelection = this.reelection
      for (const i in selected) {
        if (i === clickName) {
          selected[i] = !reelection
        } else {
          selected[i] = reelection
        }
      }
      this.reelection = !reelection
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
    },
    resetLegend(selected) {
      for (const i in selected) {
        selected[i] = true
      }
      this.reelectionName = ''
      this.reelection = false
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
      this.reelectionClick = 0
    }
  }

}
</script>

<style scoped>

</style>
